
import gsap from 'gsap';
import { Sprite } from 'pixi.js';

import { App, Shared } from '../App';
import { Browser } from '../utils/Browser';
import { AnimatedButton } from './buttons/AnimatedButton';
import { GenericButton } from './buttons/GenericButton';
import { NineSliceButton } from './buttons/NineSliceButton';
import LocalisedText from './LocalisedText';
import { Panel } from './Panel';
import { Widget } from './Widget';

export class DownloadAppPanel extends Widget
{
    public app: App;
    private panel: Panel;
    private label: LocalisedText;
    
    constructor(app: App)
    {
        super();
        this.app = app;
        
        this.panel = new Panel({
            w: this.width,
            h: this.height,
        });
        this.view.addChild(this.panel.view);
        
        // this.linkButton = this.createLinkButton();
        // this.panel.view.addChild(this.linkButton.view);
        // this.linkButton.view.y = this.height * 0.35;
        
        let sprite = new Sprite(Shared.assets.getTexture('ui_app_icon'));
        sprite.anchor.set(0.5);

        const button = new AnimatedButton(sprite);
        this.panel.view.addChild(button.view);
        button.view.y = -50;
        button.onPress.connect(() =>
        {
            Browser.open("https://geoip.turner-apps.com/bmxchampions-webgame");
        });
        
        this.label = new LocalisedText('get_the_app', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 6,
            lineJoin: 'round',
            align: 'center',
            fontSize: 32,
            maxWidth: this.width * 0.9,
            maxHeight: 100,
            wordWrap: true,
            wordWrapWidth: this.width * 0.9
        });
        this.label.y = 120;
        this.label.anchor.set(0.5);
        this.panel.view.addChild(this.label);
        
    }

    public get width(): number
    {
        return 290;
    }

    public get height(): number
    {
        return 400;
    }

    protected async onOpen(): Promise<void>
    {
        this.refresh();
        gsap.killTweensOf(this.panel.view);
        this.panel.view.x = 500;
        await gsap.to(this.panel.view, { x: 0, duration: 0.5, ease: 'expo.out', delay: 0.1 });
    }

    protected async onClose(): Promise<void>
    {
        gsap.killTweensOf(this.panel.view);
        await gsap.to(this.panel.view, { x: 500, duration: 0.3, ease: 'sine.in' });
    }

    private refresh(): void
    {
        this.label.setText("get_the_app");
    }
    
    // private createLinkButton(): NineSliceButton
    // {
    //     const buttonContent = new Sprite();
    //     const width = 220;
    //     const height = 70;

    //     button.onPress.connect(() =>
    //     {
    //         console.log("link")
    //     });

    //     return button;
    // }
}
